import rpcCall, {abortCall} from "../../../util/rpc/rpcCalls"
import {convertManagementAssignmentsDataFromRpc, convertUserAccessRightsDataFromRpc, getTimeZoneOffsets} from "../utils"
import {TabKeys, ValidationErrors} from "../constants"
import {EXCEPTIONS, pickLoggedInUserInfo} from "./util"
import messageResource from "../../../messageResource"
import UserListConfirmation from "../../../administration/userManagement/UserListConfirmation"
import {UserManagementConstants} from "../../../constants"
import {getEditUserId, getErrorBackup, getSelectedTab} from "./selectors"
import * as ActionTypes from './actionTypes'
import * as UserDataActions from '../userData/actions'
import {
    setFullUserInfo,
    setTimeZoneGroupData,
    setUserPanelErrors,
    setUserPanelHasLeavesOrTTBeforeNewHireDateError,
    updateStateFromViewerSettings
} from '../userData/actions'
import {createAction} from 'redux-actions'
import {
    validateEmail,
    validateFirstName,
    validateHireDate,
    validateLastName,
    validateReleaseDate,
    validateTimezoneGroup,
    validateUserGroupName,
    validateUserName
} from "../validation"
import _ from "underscore"
import {getLoggedInUserId} from "../../../loggedInUser/selectors"
import {
    getExtendedData,
    getFullUserInfo,
    getManagementAssignmentsSelection,
    getUserDataState,
    getUserPanelErrors,
    getUserRights,
    getWorkSchedule
} from "../userData/selectors"
import * as SyncCallbacks from './syncCallbacks'
import {
    addNewUsersToList,
    removeUserFromList,
    setLicenseCounters,
    setUserList,
    setUserManagementData,
    setUsersWithoutApprovers,
    setViewerSettings,
    updateUsersListUserGroupId,
} from "../../../administration/userManagement/common/actions"
import {setEnabledFeatures} from "../../../features/actions"
import {
    addTimeZoneGroups,
    addUser,
    addUserGroups,
    addUsers,
    removeUser,
    setTimeZoneGroupsList,
    setUserGroupsList,
} from "../../../entities/actions"
import {setAuthorizationInfo} from '../authorizationInfo/actions'
import {getUserManagementData, getUsersList, isAllowedToManageAccountSettings} from '../../../administration/userManagement/common/selectors'
import {mergeUserRates} from '../accountSettings/userRates/validationUtils'
import {getUserRates} from '../accountSettings/userRates/selectors'
import {isBTYEnabled, isURAEnabled, isWASEnabled, isWSDEnabled} from '../../../features/selectors'
import * as UserRatesActions from '../../user/accountSettings/userRates/actions'
import {isEntireManagementScopeAssigned, isManagerScopesAvailable} from '../permissions/utils'
import {compareNullableStrDates, filterMapByKey} from '../../../atUtils'
import {toast} from '../../../toasts/actions'
import {AdditionalDataConstants} from '../../../administration/userManagement/constants'
import {updateLoggedInUser} from '../../../loggedInUser/actions'
import {updateWorkAssignmentsCounters} from '../../../administration/userManagement/managementAssignmentsEditor/actions'
import {getUsers} from '../../../entities/selectors'
import {isAborted} from '../../../util/rpc/rpcUtils'
import {NoSuchUserGroupError, SelectedUserDeletedError} from '../../errors'
import {PasswordValidators} from '../../../util/passwords/PasswordSettings'
import {managementAssignmentsCountsLoadSuccess} from '../userData/actions'
import {setDefaultWorkStatusPlanningData, setWorkStatuses} from '../accountSettings/workStatuses/actions'
import ClassicBridge from '../../../next/ClassicBridge'
import {ApiErrorKeys} from '../../../next/constants'

export const setEditingUserId = createAction(ActionTypes.EDIT_USER_ID_SET)

export const setUserPanelLoading = createAction(ActionTypes.USER_PANEL_LOADING_SET)

export const setUpdatingData = createAction(ActionTypes.UPDATING_DATA_SET)

export const setUserPanelTab = createAction(ActionTypes.USER_PANEL_TAB_SET)

export const setUserPanelState = createAction(ActionTypes.USER_PANEL_STATE_SET)

export const setLoaded = createAction(ActionTypes.LOADED_SET)

export const setUpdatingWorkSchedule = createAction(ActionTypes.UPDATING_WORK_SCHEDULE_SET)

export const updateErrorBackup = createAction(ActionTypes.ERROR_BACKUP_UPDATE)

export const setLastLicenseManagerOnDeleteAlertShown = createAction(ActionTypes.LAST_LICENSE_MANAGER_ON_DELETE_ALERT_SHOWN_SET)
export const setLastLicenseManagerOnDisableAtAlertShown = createAction(ActionTypes.LAST_LICENSE_MANAGER_ON_DISABLE_AT_ALERT_SHOWN_SET)
export const setLastLicenseManagerOnDisableApAlertShown = createAction(ActionTypes.LAST_LICENSE_MANAGER_ON_DISABLE_AP_ALERT_SHOWN_SET)

export const GET_EDIT_USER_DATA_METHOD = 'UserManagementService.getEditUserData'

export const openEditUserPanel = (userId, tab = TabKeys.ACCOUNT_SETTINGS) => (dispatch, getState) => {
    const editUserId = getEditUserId(getState())
    if (editUserId !== userId) {
        dispatch(setUserPanelState({
            userId: userId,
            selectedTab: tab,
        }))
        dispatch(reloadUserData())
    } else {
        if (getSelectedTab(getState()) !== tab) {
            dispatch(setUserPanelTab(tab))
        } else {
            dispatch(closeEditUserPanel())
        }
    }
}

export const reloadUserData = () => dispatch => {
    abortCall(GET_EDIT_USER_DATA_METHOD)
    dispatch(setLoaded(true))
    dispatch(setLoaded(false))
}

export const restoreState = () => (dispatch, getState) => {
    const backup = getErrorBackup(getState())
    dispatch(setFullUserInfo(backup))
    const providerErrors = filterMapByKey(getUserPanelErrors(getState()), ValidationErrors.USERNAME_DUPLICATE)
    let validationResult = validateFirstName(providerErrors, backup.firstName)
    validationResult = validateLastName(validationResult.errors, backup.lastName)
    validationResult = validateUserName(validationResult.errors, backup.username)
    validationResult = validateEmail(validationResult.errors, backup.email, false, backup.email)
    validationResult = validateHireDate(validationResult.errors, false, Date.parseJSONDate(backup.hireDate))
    const releaseDate = backup.releaseDate ? Date.parseJSONDate(backup.releaseDate) : null
    validationResult = validateReleaseDate(validationResult.errors, releaseDate, Date.parseJSONDate(backup.hireDate), backup.releaseDate)
    dispatch(setUserPanelErrors(validationResult.errors))
}

export const loadEditUserPanelData = () => (dispatch, getState) => {
    const editUserId = getEditUserId(getState())
    dispatch(loadEditUserPanelDataWithId(editUserId))
}

export const loadEditUserPanelDataWithId = (editUserId) => (dispatch, getState) => {
    dispatch(setUserPanelLoading(true))
    const manageAccountsOfViewerWasEnabled = isAllowedToManageAccountSettings(getState())

    const WSDEnabled = isWSDEnabled(getState())

    const loads =[makeRpcCall(
            GET_EDIT_USER_DATA_METHOD,
            [editUserId]
        ),
        WSDEnabled && ClassicBridge.getWorkStatusesForUserProfile(),
        WSDEnabled && ClassicBridge.getUsersByClassicIds([editUserId])
    ]

    Promise.all(loads)
    .then(([userClassicData, workStatuses, usersNextData]) => {
        if (!WSDEnabled) {
            return [userClassicData]
        }

        const [userNextData] = usersNextData.items
        return new Promise((res) => ClassicBridge.getDefaultWorkStatusPlanningByUserId(userNextData.id).then((defaultWorkStatusPlanningData) => res([
            userClassicData, workStatuses, userNextData, defaultWorkStatusPlanningData
        ])))
    })
    .then(([userClassicData, workStatuses, userNextData, defaultWorkStatusPlanningData]) => {
        dispatch(UserDataActions.clearUserPanelErrors())
        dispatch(UserRatesActions.clearErrors())

        const manageAccountsOfViewerIsEnabled = userClassicData.userManagementData.viewerSettings.allowedToManageAccountSettings
        if (!manageAccountsOfViewerWasEnabled && manageAccountsOfViewerIsEnabled) {
            alert(messageResource.getMessage("userlist.manage_accounts_were_granted"))
            window.location.reload()
        }

        dispatch(updateStateFromEditUserData(userClassicData))

        const fullUserInfo = {
            ...userClassicData['fullUserInfo']['userAccountSettings'],
            password: "",
            retypedPassword: "",
        }
        const userGroupRowData = {
            groupId: fullUserInfo.userGroupId,
            newGroupCreating: false,
        }
        const userManagementData = userClassicData['userManagementData']
        const timeZoneGroupRowData = {
            groupId: fullUserInfo.timeZoneGroupId,
            newGroupCreating: false,
            timeZoneGroupsOffset: getTimeZoneOffsets(userManagementData.allTimeZoneGroups),
            newTimeZonEGroup: null,
        }

        const rates = fullUserInfo.rates ? [...fullUserInfo.rates] : []

        dispatch(setUserManagementData(userManagementData))
        dispatch(UserDataActions.setUserData({
            fullUserInfo: {
                ...fullUserInfo,
                rates
            },
            userGroupRowData,
            timeZoneGroupRowData,
            hasTimeTrack: userClassicData['hasTimeTrack'],
            firstTTDate: userClassicData['firstTTDate'],
            firstLeaveRequestDate: userClassicData['firstLeaveRequestDate'],
            lastLoginTime: userClassicData['lastLoginTime'],
            lastOtherProductAdmin: userClassicData['lastOtherProductAdmin'],
            userTeamAssignmentsData: userClassicData['userTeamAssignmentsData'],
            allApprovers: userClassicData['allApprovers'] ? userClassicData['allApprovers'] :  {},
            userNextId: WSDEnabled && userNextData.id,
            extendedData: {
                lastLoginTime: userClassicData['lastLoginTime'],
                firstTTDate: userClassicData['firstTTDate'],
                hasTimeTrack: userClassicData['hasTimeTrack'],
                lastOtherProductAdmin: userClassicData['lastOtherProductAdmin'],
                lastLicensesManager: userClassicData['lastLicensesManager'],
                currentTime: userClassicData['currentTimeInUserTimeZone'],
                firstRequestDate: userClassicData['firstRequestDate'],
                isAllowedToSeeAllUsersTT: userClassicData['userIsAllowedToSeeAllUsersTT'],
            }
        }))

        if (!!userClassicData['userManageAssignmentsData']) {
            dispatch(UserDataActions.setUserManageAssignmentsData(convertManagementAssignmentsDataFromRpc(userClassicData['userManageAssignmentsData'])))
        } else {
            dispatch(UserDataActions.setUserManageAssignmentsData({
                managementAssignmentsSelection: userClassicData['managementAssignmentsSelection']
            }))
        }

        const maCountersData = userClassicData['managementAssignmentsCounters']
        dispatch(UserDataActions.managementAssignmentsCountsLoadSuccess({
            customers: maCountersData ? maCountersData.customers : 0,
            projects: maCountersData ? maCountersData.projects : 0,
            tasks: maCountersData ? maCountersData.tasks : 0
        }))

        dispatch(setUserList(userClassicData.availableUsers.list))

        if (WSDEnabled) {
            dispatch(setWorkStatuses(workStatuses))
            dispatch(setDefaultWorkStatusPlanningData(defaultWorkStatusPlanningData))
        }

        dispatch(setAuthorizationInfo(userClassicData['authorizationInfo']))

        dispatch(setLoaded(true))
        dispatch(setUserPanelLoading(false))
        dispatch(updateErrorBackup({...fullUserInfo, rates}))
        if (userClassicData['authorizationInfo']['accountInformationEditable'] && !fullUserInfo.email)
            setTimeout(() => dispatch(setUserPanelErrors({[ValidationErrors.EMAIL_WAS_EMPTY]: true})), 300)
        if (compareNullableStrDates(fullUserInfo.hireDate, fullUserInfo.releaseDate) > 0) {
            setTimeout(() => dispatch(setUserPanelErrors({[ValidationErrors.RELEASE_DATE_WAS_BEFORE_HIRE_DATE]: true})), 300)
        }

    }).catch(error => {
        if (isAborted(error)) {
            return
        }

        dispatch(setEditingUserId(null))
        dispatch(setUserPanelLoading(false))
        if (error._providerStatus === ValidationErrors.NO_SUCH_USER) {
            alert(messageResource.getEscapedMessage("user.js.error_user_was_deleted"))

            dispatch(updateStateOnUserDelete(editUserId))
            SyncCallbacks.onNoSuchUserException(editUserId)
            dispatch(removeUserFromList(editUserId))
        }
        if (error._providerStatus === ValidationErrors.USER_IS_LOCKED) {
            // todo: lamanov change message
            alert(messageResource.getEscapedMessage("userlist.js.error_no_such_user"))
        }
    })
}

export const closeEditUserPanel = () => dispatch => {
    abortCall(GET_EDIT_USER_DATA_METHOD)
    dispatch(setEditingUserId(null))
    dispatch(UserDataActions.clearUserPanelErrors())
    dispatch(UserRatesActions.clearErrors())
}

export const deleteUser = (force = false, forceLastLicenseManagerUpdate = false) => (dispatch, getState) => {
    const state = getState()
    const userId = getEditUserId(state);
    dispatch(UserDataActions.removeUserPanelErrors([ValidationErrors.ACTION_NOT_CONFIRMED, ValidationErrors.ACTION_CONFIRMED]))

    dispatch(setUpdatingData(true))
    makeRpcCall("UserManagementService.deleteUser", [userId, force, forceLastLicenseManagerUpdate])
        .then(data => {
            dispatch(setUpdatingData(false))
            dispatch(closeEditUserPanel())

            dispatch(updateStateOnUserDeleteSuccess(userId, data))
            dispatch(updateAdditionalData(data, state))
            SyncCallbacks.onDeleteUser({...data, id: userId})
        })
        .catch(error => {
            dispatch(setUpdatingData(false))
            if (error._providerStatus === ValidationErrors.ACTION_CONFIRMED) {
                dispatch(deleteUser(true))
            }

            if (error._providerStatus === ValidationErrors.NO_SUCH_USER) {
                alert(messageResource.getEscapedMessage("userlist.js.error_no_such_user"))

                dispatch(updateStateOnUserDelete(userId))
                SyncCallbacks.onDeleteUser({...error, id: userId})
            }
            if (error._providerStatus === ValidationErrors.USER_IS_LOCKED) {
                // todo: lamanov change message
                alert(messageResource.getEscapedMessage("userlist.js.error_no_such_user"))
            }
            if (error._providerStatus === ValidationErrors.LAST_MANAGER_IN_OTHER_PRODUCT) {
                alert(messageResource.getMessage("user.edit.js.cannot_delete.last_admin_ap"))
                dispatch(UserDataActions.addUserPanelErrors([error._providerStatus]))
                dispatch(UserDataActions.updateExtendedData({
                    lastOtherProductAdmin: true,
                }))
            }
            if (error._providerStatus === 'UserIsLastLicensesManagerException') {
                if (forceLastLicenseManagerUpdate)
                    dispatch(deleteUser(force, true))
                else
                    dispatch(setLastLicenseManagerOnDeleteAlertShown(true))
            }
        })
}

export const updateFirstName = (newFName) => (dispatch, getState) => {
    const state = getState()
    const providerErrors = getUserPanelErrors(state)

    const validationResult = validateFirstName(providerErrors, newFName)
    dispatch(updateErrorBackup(getFullUserInfo(getState())))
    if (validationResult.isValid) {
        dispatch(performUpdateCall("UserManagementService.updateFirstName", [newFName]))
    } else {
        dispatch(UserDataActions.setFullUserInfo({firstName: newFName}));
    }
    dispatch(UserDataActions.setUserPanelErrors(validationResult.errors));

}

export const updateLastName = (newLName) => (dispatch, getState) => {
    const state = getState()
    const providerErrors = getUserPanelErrors(state)

    const validationResult = validateLastName(providerErrors, newLName)
    dispatch(updateErrorBackup(getFullUserInfo(getState())))
    if (validationResult.isValid) {
        dispatch(performUpdateCall("UserManagementService.updateLastName", [newLName]))
    } else {
        dispatch(UserDataActions.setFullUserInfo({lastName: newLName}));
    }
    dispatch(UserDataActions.setUserPanelErrors(validationResult.errors));

}


export const updateDefaultWorkStatuses = (newDefaultWorkStatuses) => (dispatch, getState) => {
    const state = getState()
    const userInfo = getUserDataState(state)
    dispatch(setUpdatingData(true))
    ClassicBridge
        .putUserDefaultWorkStatuses(userInfo.userNextId, { items: newDefaultWorkStatuses })
        .then(() => {
            dispatch(setUpdatingData(false))
        })
        .catch((e) => {
            if (e.body && e.body.errorKey === ApiErrorKeys.NotFoundEntity && e.body.entityType === 'user') {
                alert(messageResource.getMessage('userlist.js.error_no_such_user.edit_user' ));
                dispatch(updateStateOnUserDelete(userInfo.fullUserInfo.id))
                return dispatch(setEditingUserId(null))
            } else if (e.body && e.body.errorKey === ApiErrorKeys.NotFoundEntity && e.body.entityType === 'target') {
                alert(messageResource.getMessage('userlist.js.error_no_such_work_status.edit_user'));
                return document.location.reload();
            }
            alert(messageResource.getMessage('error.js.lightbox_loader.unexpected_error', [PRODUCT_NAME]));
        })
}

export const updateMiddleName = (newMName) => dispatch => {
    dispatch(performUpdateCall("UserManagementService.updateMiddleName", [newMName]))
}

export const updateUserName = (newUName, duplicateError) => (dispatch, getState) => {
    //updating state by modifying panel errors
    if (duplicateError) {
        dispatch(UserDataActions.addUserPanelErrors([ValidationErrors.DUPLICATE_USERNAME]))
    } else {
        dispatch(UserDataActions.removeUserPanelErrors([ValidationErrors.DUPLICATE_USERNAME]))
    }

    //calling getState() to retrieve updated set of errors
    const providerErrors = getUserPanelErrors(getState())

    const validationResult = validateUserName(providerErrors, newUName)
    dispatch(updateErrorBackup(getFullUserInfo(getState())))
    if (validationResult.isValid) {
        dispatch(performUpdateCall("UserManagementService.updateUsername", [newUName]))
    }
    dispatch(UserDataActions.setUserPanelErrors(validationResult.errors));

}

export const updateEmail = (newEmail) => (dispatch, getState) => {
    const state = getState()
    const providerErrors = getUserPanelErrors(state)
    const backupEmail = getErrorBackup(getState()).email
    const validationResult = updateEmailValidation(dispatch, newEmail, backupEmail, providerErrors)
    dispatch(updateErrorBackup(getFullUserInfo(getState())))
    if (validationResult.isValid) {
        dispatch(performUpdateCall("UserManagementService.updateEmail", [newEmail]))
    } else {
        dispatch(UserDataActions.setFullUserInfo({email: newEmail}));
    }
}

export const updatePassword = (newPassword, retypedPassword, isPasswordChanged, isPasswordCopyChanged) => (dispatch, getState) => {
    const state = getState()
    const providerErrors = getUserPanelErrors(state)

    function removeOldErrors() {
        dispatch(UserDataActions.removeUserPanelErrors([
            ValidationErrors.PASSWORDS_DO_NOT_MATCH,
            ValidationErrors.PASSWORD_COPY_EMPTY,
            ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED
        ]))
        dispatch(UserDataActions.setPasswordValidationResult(null));
    }

    // clear all errors if main password field is empty
    if (newPassword.length === 0) {
        removeOldErrors();
        dispatch(UserDataActions.setFullUserInfo({
            password: "",
            retypedPassword: retypedPassword,
        }))
    } else {
        if (providerErrors.length > 0) {
            return; //there are already errors
        }
        removeOldErrors();

        dispatch(performUpdateCall("UserManagementService.changePassword", [newPassword, retypedPassword]))
        dispatch(UserDataActions.setFullUserInfo({
            password: newPassword,
            retypedPassword: retypedPassword
        }))
    }
}

export const updateUserGroup = (ugrId, newUgrName) => (dispatch, getState) => {
    const state = getState()
    const providerErrors = getUserPanelErrors(state)
    const userId = getEditUserId(state)

    const validationResult = validateUserGroupName(providerErrors, ugrId, newUgrName)

    if (validationResult.isValid) {
        dispatch(performUpdateCall("UserManagementService.updateUserGroup", [ugrId, newUgrName],
            (resultData) => {
                dispatch(UserDataActions.setAllApprovers(resultData.allApprovers))
                // update user group id in usersList for user
                if (ugrId !== resultData.userInfo.userGroupId)
                    dispatch(updateUsersListUserGroupId({userId, userGroupId: resultData.userInfo.userGroupId}))
            }))
    } else {
        dispatch(UserDataActions.setUserGroupData({
            userGroupId: ugrId,
        }))
        dispatch(UserDataActions.setFullUserInfo({
            userGroupId: ugrId,
            newUserGroupName: newUgrName
        }))
    }
    dispatch(UserDataActions.setUserPanelErrors(validationResult.errors));
}

export const updateTimeZoneGroup = (tzgId, newTzg) => (dispatch, getState) => {
    const state = getState()

    dispatch(UserDataActions.removeUserPanelErrors([
        ValidationErrors.DUPLICATE_TIME_ZONE_GROUP,
        ValidationErrors.CITY_DATA_EMPTY,
        ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY
    ]))
    const providerErrors = getUserPanelErrors(state)

    const validationResult = validateTimezoneGroup(providerErrors, tzgId, newTzg)

    if (validationResult.isValid) {
        dispatch(performUpdateCall("UserManagementService.updateTimezoneGroup", [tzgId, newTzg]))
    }
    dispatch(UserDataActions.setUserPanelErrors(validationResult.errors));
}

export const updateHireDate = (hireDate, forceUpdate) => (dispatch, getState) => {
    const state = getState()

    dispatch(UserDataActions.removeUserPanelErrors([ValidationErrors.LAST_MANAGER_IN_OTHER_PRODUCT]))
    const providerErrors = getUserPanelErrors(state)

    const isEditHimself = getLoggedInUserId(state) === getEditUserId(state)

    const releaseDate = getFullUserInfo(state).releaseDate ? Date.parseJSONDate(getFullUserInfo(state).releaseDate) : null
    let validationResult = validateHireDate(providerErrors, isEditHimself, Date.parseJSONDate(hireDate), releaseDate)
    if (validationResult.isValid) {
        validationResult = validateReleaseDate(providerErrors, releaseDate, Date.parseJSONDate(hireDate))
    }

    if (validationResult.isValid) {
        dispatch(setUserPanelHasLeavesOrTTBeforeNewHireDateError(false))
        dispatch(performUpdateCall(
            "UserManagementService.updateHireDate",
            [Date.parseJSONDate(hireDate), forceUpdate],
            (data) => {
                if (data.additionalResultData !== null) {
                    const additionalData = data.additionalResultData.map
                    dispatch(UserDataActions.setUserData({
                            firstTTDate: additionalData['firstTTDate'],
                            firstLeaveRequestDate: additionalData['firstLeaveRequestDate'],
                            extendedData: {
                                ...getExtendedData(getState()),
                                currentTime: additionalData['currentTimeInUserTimeZone'],
                                firstTTDate: additionalData['firstTTDate'],
                                firstLeaveRequestDate: additionalData['firstLeaveRequestDate'],
                            }
                        })
                    )
                }
            },
            (err) => {
                if(err._providerStatus === ValidationErrors.LEAVES_OR_TT_BEFORE_NEW_HIRE_DATE) {
                    dispatch(setUserPanelHasLeavesOrTTBeforeNewHireDateError(true))
                }
                if(err._providerStatus === ValidationErrors.LAST_MANAGER_IN_OTHER_PRODUCT) {
                    alert(messageResource.getEscapedMessage("user.edit.js.cannot_disable.last_admin_at"))
                }
            }),
        )
    } else {
            dispatch(UserDataActions.setFullUserInfo({
            hireDate
        }));
    }
    dispatch(UserDataActions.setUserPanelErrors(validationResult.errors));
}

export const setHasLeavesOrTTBeforeNewHireDateError = (userPanelHasLeavesOrTTBeforeNewHireDateError) => (dispatch) => {
    dispatch(setUserPanelHasLeavesOrTTBeforeNewHireDateError(userPanelHasLeavesOrTTBeforeNewHireDateError))
}

export const updateReleaseDate = (releaseDate) => (dispatch, getState) => {
    const state = getState()

    const providerErrors = getUserPanelErrors(state)
    let jsonDate = releaseDate ? Date.parseJSONDate(releaseDate) : null
    const hireDate = Date.parseJSONDate(getFullUserInfo(state).hireDate)
    const backupReleaseDate = getErrorBackup(getState()).releaseDate
    const validationResult = validateReleaseDate(providerErrors, jsonDate, hireDate, backupReleaseDate)

    if (validationResult.isValid) {
        dispatch(performUpdateCall("UserManagementService.updateReleaseDate", [jsonDate]))
    } else {
        dispatch(UserDataActions.setFullUserInfo({releaseDate}))
    }
    dispatch(UserDataActions.setUserPanelErrors(validationResult.errors));
}

export const updateUserRights = (accessRights = [], force = false) => (dispatch, getState) => {
    const oldRights = getFullUserInfo(getState()).accessRights
    const isEntireScope = isEntireManagementScopeAssigned(getManagementAssignmentsSelection(getState()), getUserRights(getState()))
    const hasAccessToManagementScope = isManagerScopesAvailable(getUserRights(getState()), {
        isURAEnabled: isURAEnabled(getState()),
        isBTYEnabled: isBTYEnabled(getState()),
    })
    const isWAFeatureEnabled = isWASEnabled(getState())
    dispatch(performUpdateCall("UserManagementService.updateUserRights", [accessRights, force],
        data => {
            dispatch(UserDataActions.setFullUserInfo({
                accessRights: convertUserAccessRightsDataFromRpc(data.userInfo)
            }))

            dispatch(addUser(data.userInfo))
            dispatch(updateWorkAssignmentsCounters(data))
            const maCountersData = data.additionalResultData.map['managementAssignmentsCounters']
            if (maCountersData) {
                dispatch(managementAssignmentsCountsLoadSuccess(maCountersData))
            }

            const revokeAllManagementScope = isEntireScope  && !isEntireManagementScopeAssigned(getManagementAssignmentsSelection(getState()), getUserRights(getState()))
            const revokeAccessToManagementScope = hasAccessToManagementScope && !isManagerScopesAvailable(getUserRights(getState()), {
                isURAEnabled: isURAEnabled(getState()),
                isBTYEnabled: isBTYEnabled(getState()),
            })
            if ((revokeAccessToManagementScope || revokeAllManagementScope) && isWAFeatureEnabled) {
                dispatch(toast(messageResource.getMessage('user_list.toasts.revoke_all_management_scope')))
            }
        },
        error => {
            if (error._providerStatus === ValidationErrors.ACTION_CONFIRMED) {
                dispatch(updateUserRights(accessRights, true))
            } else if (error._providerStatus === ValidationErrors.ACTION_NOT_CONFIRMED) {
                dispatch(UserDataActions.setFullUserInfo({
                    accessRights: oldRights
                }))
            }
        })
    )
}

export const updateAccess = (enabled, force, forceLastLicenseManagerUpdate = false) => (dispatch, getState) => {
    const wasEnabled = getFullUserInfo(getState()).enabled
    dispatch(UserDataActions.removeUserPanelErrors([ValidationErrors.ACTION_CONFIRMED, ValidationErrors.ACTION_NOT_CONFIRMED]))

    dispatch(performUpdateCall("UserManagementService.updateAccess", [enabled, force, forceLastLicenseManagerUpdate],
        data => {
            dispatch(UserDataActions.setFullUserInfo({
                enabled: data.userInfo.enabled
            }));
        },
        error => {
            if (error._providerStatus === ValidationErrors.ACTION_CONFIRMED) {
                dispatch(updateAccess(enabled, true, forceLastLicenseManagerUpdate))
            } else if (error._providerStatus === ValidationErrors.ACTION_NOT_CONFIRMED) {
                dispatch(UserDataActions.setFullUserInfo({
                    enabled: wasEnabled
                }))
            } else if (error._providerStatus === ValidationErrors.DISABLED_DUE_TO_LICENSE_TERMS) {
                dispatch(UserDataActions.setFullUserInfo({
                    enabled: false
                }))
            } else if (error._providerStatus === 'UserIsLastLicensesManagerException') {
                if (forceLastLicenseManagerUpdate)
                    dispatch(updateAccess(enabled, force, true))
                else
                    dispatch(setLastLicenseManagerOnDisableAtAlertShown(true))
            }
        })
    )
}

export const updateAccessAP = (enabled, force, forceLastLicenseManagerUpdate = false) => (dispatch, getState) => {
    const wasEnabled = getFullUserInfo(getState()).enabledInOtherProduct
    dispatch(UserDataActions.removeUserPanelErrors([ValidationErrors.LAST_MANAGER_IN_OTHER_PRODUCT]))

    dispatch(UserDataActions.setFullUserInfo({
        enabledInOtherProduct: enabled
    }))

    dispatch(performUpdateCall("UserManagementService.updateAccessOtherProduct", [enabled, force, forceLastLicenseManagerUpdate],
        data => {
            dispatch(UserDataActions.setFullUserInfo({
                enabledInOtherProduct: data.userInfo.enabledInOtherProduct
            }));
            dispatch(setAuthorizationInfo(data.additionalResultData.map['authorizationInfo']))
        },
        error => {
            if (error._providerStatus === ValidationErrors.ACTION_CONFIRMED) {
                dispatch(updateAccessAP(enabled, true, forceLastLicenseManagerUpdate))
            } else if (error._providerStatus === ValidationErrors.ACTION_NOT_CONFIRMED) {
                dispatch(UserDataActions.setFullUserInfo({
                    enabledInOtherProduct: wasEnabled
                }))
            } else if (error._providerStatus === ValidationErrors.DISABLED_DUE_TO_LICENSE_TERMS) {
                dispatch(UserDataActions.setFullUserInfo({
                    enabledInOtherProduct: false
                }))
            } else if (error._providerStatus === 'UserIsLastLicensesManagerException') {
                if (forceLastLicenseManagerUpdate)
                    dispatch(updateAccessAP(enabled, force, true))
                else
                    dispatch(setLastLicenseManagerOnDisableApAlertShown(true))
            }
        })
    )
}

export const updateRequireApproval = (needApproval) => dispatch => {
    dispatch(performUpdateCall("UserManagementService.updateApproval", [needApproval]))
}

export const updateOvertime = (level) => (dispatch) => {

    dispatch(performUpdateCall("UserManagementService.updateOvertime", [level],
        () => {
            dispatch(UserDataActions.setFullUserInfo({
                overtimeLevel: level
            }));
        })
    )
}

export const updateUserSchedules = (workSchedules = []) => (dispatch, getState) => {
    const userManagementData = getUserManagementData(getState())
    const currentDate = userManagementData.todayInViewerTimeZone.parseJSONDate()
    workSchedules = workSchedules.map(ws => {
        const sameAsDefault = ws.effectiveDate !== null && ws.effectiveDate.parseJSONDate() >= currentDate ? ws.sameAsDefault : false
        return {
            ...ws,
            sameAsDefault,
            durations: sameAsDefault ? userManagementData.defaultWorkSchedule : ws.durations
        }
    })

    dispatch(UserDataActions.removeUserPanelErrors([ValidationErrors.DUPLICATED_EFFECTIVE_DATE]))

    const schedulesToUpdate = workSchedules.filter(ws => ws.effectiveDate !== null)

    dispatch(setUpdatingWorkSchedule(true))

    dispatch(performUpdateCall("UserManagementService.updateUserSchedules", [schedulesToUpdate],
        () => {
            dispatch(setUpdatingWorkSchedule(false))
            dispatch(UserDataActions.setFullUserInfo({
                workSchedule: workSchedules
            }))
        },
        error => {
            dispatch(setUpdatingWorkSchedule(false))
            if (error._providerStatus === ValidationErrors.DUPLICATED_EFFECTIVE_DATE) {
                alert(messageResource.getMessage('userlist.userdata.schedules.duplicate_effective'));
                dispatch(UserDataActions.setFullUserInfo({
                    defaultInitialSchedule: error.defaultInitialSchedule,
                    initialSchedule: error.initialSchedule,
                    workSchedule: error.workSchedule
                }))
            }
        })
    )
}

export const addNewSchedule = () => (dispatch, getState) => {
    const state = getState()
    const workSchedule = getWorkSchedule(state)
    const userManagementData = getUserManagementData(state)
    const currentDateStr = userManagementData.todayInViewerTimeZone.parseJSONDate().toJSON()
    const effectiveDate = workSchedule.find(ws => ws.effectiveDate === currentDateStr) ? null : currentDateStr

    const newSchedule = {
        effectiveDate,
        durations: userManagementData.defaultWorkSchedule,
        sameAsDefault: effectiveDate === currentDateStr
    }

    if (newSchedule.effectiveDate !== null) {
        dispatch(updateUserSchedules([...workSchedule, newSchedule].map(ws => ({...ws, oldEffectiveDate: ws.effectiveDate}))))
    } else {
        dispatch(UserDataActions.setFullUserInfo({
            workSchedule: [...workSchedule, newSchedule]
        }))
    }
}

export const updateInitialUserSchedule = ({
    isDefaultInitialSchedule = false,
    initialSchedule = [],
}) => (dispatch, getState) => {
    initialSchedule = isDefaultInitialSchedule ? getUserManagementData(getState()).defaultWorkSchedule : initialSchedule

    dispatch(setUpdatingWorkSchedule(true))
    dispatch(performUpdateCall("UserManagementService.updateInitialUserSchedule", [isDefaultInitialSchedule, initialSchedule],
        () => {
            dispatch(UserDataActions.setFullUserInfo({
                defaultInitialSchedule: isDefaultInitialSchedule,
                initialSchedule: initialSchedule,
            }))
            dispatch(setUpdatingWorkSchedule(false))
        }),
        () => {
            dispatch(setUpdatingWorkSchedule(false))
        }
    )
}

export const deleteUserSchedule = ({scheduleToRemove = [], removePermanently = false, index}) => (dispatch, getState) => {
    const state = getState()
    const workSchedule = [...getFullUserInfo(state).workSchedule]

    if (removePermanently) {
        workSchedule.splice(index, 1)
        dispatch(UserDataActions.setFullUserInfo({
            workSchedule: workSchedule
        }))
    } else {
        dispatch(setUpdatingWorkSchedule(true))
        dispatch(performUpdateCall("UserManagementService.deleteUserSchedule", [scheduleToRemove],
            () => {
                dispatch(setUpdatingWorkSchedule(false))
                dispatch(UserDataActions.setFullUserInfo({
                    workSchedule: workSchedule.filter(ws => ws.effectiveDate !== scheduleToRemove.oldEffectiveDate)
                }))
            }),
            () => {
                dispatch(setUpdatingWorkSchedule(false))
            }
        )
    }
}

export const changeTeamAssignments = ({teamAssignmentType, assignedGroupIds}) => (dispatch, getState) => {
    const editUserId = getEditUserId(getState())
    dispatch(changeTeamAssignmentsWithId(editUserId, {teamAssignmentType, assignedGroupIds}))
}

export const changeTeamAssignmentsWithId = (userId, {teamAssignmentType = '', assignedGroupIds = [], assignedUserIds = []}) => (dispatch) => {
    dispatch(performUpdateCallWithId(userId, "UserManagementService.saveUserTeamAssignments", [teamAssignmentType, assignedGroupIds, assignedUserIds],
        data => {
            const teamAssignmentsData = data.additionalResultData.map['userTeamAssignmentsData']
            dispatch(UserDataActions.setUserTeamAssignmentsData(teamAssignmentsData))
        },
        error => {
            if (error instanceof SelectedUserDeletedError) {
                alert(messageResource.getMessage('userlist.js.error_selected_user_deleted'))
                dispatch(reloadUserData())
                return true
            }
            if (error instanceof NoSuchUserGroupError) {
                alert(messageResource.getMessage('userlist.js.error_selected_user_group_deleted'))
                dispatch(reloadUserData())
                return true
            }
        })
    )
}

const updateEmailValidation = (dispatch, email, backupEmail, providerErrors) => {
    const validationResult = validateEmail(providerErrors, email, false, backupEmail)
    dispatch(UserDataActions.setUserPanelErrors(validationResult.errors))
    return validationResult
}

export const performUpdateCall = (method, params, dataHandler, errorHandler) => (dispatch, getState) => {
    const editUserId = getEditUserId(getState())
    dispatch(performUpdateCallWithId(editUserId, method, params, dataHandler, errorHandler))
}

const performUpdateCallWithId = (editUserId, method, params, dataHandler = () => {}, errorHandler = () => {}) => (dispatch, getState) => {
    dispatch(setUpdatingData(true))

    const prevState = getState()

    makeRpcCall(method, [editUserId, ...params])
        .then(data => {
            const userInfo = data.userInfo;

            if (getLoggedInUserId(prevState) === editUserId) {
                dispatch(updateLoggedInUser(pickLoggedInUserInfo(userInfo)))
            }

            const userManagementData = {
                viewerSettings: data.viewerSettings,
            }
            if (data.userGroups) {
                userManagementData.allUserGroups = data.userGroups
            }
            if (data.timeZoneGroups) {
                userManagementData.allTimeZoneGroups = data.timeZoneGroups
            }
            dispatch(setUserManagementData(userManagementData));

            dispatch(UserDataActions.setFullUserInfo({
                ...userInfo,
                accessRights: convertUserAccessRightsDataFromRpc(userInfo)
            }));

            dispatch(updateAdditionalData(data, prevState))
            dispatch(setUpdatingData(false))
            dispatch(updateStateFromUpdateResult(data))
            dataHandler(data)
            SyncCallbacks.onUpdateUserData(data)
        })
        .catch(error => {
            dispatch(setUpdatingData(false))
            errorHandler(error)
            dispatch(UserDataActions.setPasswordValidationResult(
                error.additionalResultData ? error.additionalResultData.map[PasswordValidators.PASSWORD_VALIDATION_RESULT_JSON] : null)
            );
            dispatch(UserDataActions.addUserPanelErrors([error._providerStatus]));
            dispatch(handleCommonErrors(error))
        })
}

const updateAdditionalData = (data, prevState) => (dispatch) => {
    if (data.additionalResultData) {
        const additionalData = data.additionalResultData.map

        if (additionalData.rates) {
            dispatch(UserDataActions.setFullUserInfo({
                rates: isURAEnabled(prevState) ? mergeUserRates(getUserRates(prevState), additionalData.rates) : additionalData.rates
            }))
        }

        if (!!additionalData[AdditionalDataConstants.USERS_WITHOUT_APPROVERS_DATA]) {
            dispatch(setUsersWithoutApprovers(additionalData[AdditionalDataConstants.USERS_WITHOUT_APPROVERS_DATA]))
        }

        if (!!additionalData[AdditionalDataConstants.ALL_USERS_AUTOAPPROVED]) {
            dispatch(setUsersAutoApproved())
        }

        if (!!additionalData[AdditionalDataConstants.ACTIVE_LEAVE_TYPES]) {
            dispatch(setUserManagementData({
                activeLeaveTypes: additionalData.activeLeaveTypes
            }))
        }

        if (!!additionalData[AdditionalDataConstants.TIME_ZONE_GROUPS_DATA]) {
            const allTimeZoneGroupOffsets = getTimeZoneOffsets(additionalData[AdditionalDataConstants.TIME_ZONE_GROUPS_DATA].list)
            dispatch(setUserManagementData({allTimeZoneGroupOffsets}))
            dispatch(setTimeZoneGroupData({timeZoneGroupsOffset: allTimeZoneGroupOffsets}))
        }
    }
}

const handleCommonErrors = (data) => (dispatch, getState) => {
    const editUserId = getEditUserId(getState())

    if (data._providerStatus === ValidationErrors.NO_SUCH_USER) {
        alert(messageResource.getEscapedMessage("userlist.js.error_no_such_user"))

        dispatch(updateStateOnUserDelete(editUserId))
        SyncCallbacks.onDeleteUser({...data, id: editUserId})
        dispatch(setEditingUserId(null))
    }
    if (data._providerStatus === ValidationErrors.USER_IS_LOCKED) {
        // todo: lamanov change message
        alert(messageResource.getEscapedMessage("userlist.js.error_no_such_user"))
        dispatch(setEditingUserId(null))
    }
}

function makeRpcCall(method, params) {
    return new Promise((resolve, reject) => {
        const _rpcErrorHandler = (error) => {
            const errorThrown = error.getErrorThrown()
            error.handleOnException(EXCEPTIONS.LeavesOrTTBeforeNewHireDateException, {_providerStatus: ValidationErrors.LEAVES_OR_TT_BEFORE_NEW_HIRE_DATE});
            error.handleOnException(EXCEPTIONS.UserIsLockedException, {_providerStatus: ValidationErrors.USER_IS_LOCKED});
            error.handleOnException(EXCEPTIONS.UserEmailInvalidException, {_providerStatus: ValidationErrors.EMAIL_INVALID});
            error.handleOnException(EXCEPTIONS.NoSuchUserException, {_providerStatus: ValidationErrors.NO_SUCH_USER});
            error.handleOnException(EXCEPTIONS.UserIsLastLicensesManagerException, {_providerStatus: "UserIsLastLicensesManagerException"});

            if (errorThrown.exception === EXCEPTIONS.NoRightsToManageAccountSettings) {
                alert(messageResource.getEscapedMessage("userlist.js.error_manage_account_settings_right_revoked"))
                window.location.reload();
                error.handle();
            }
            error.handleOnException(EXCEPTIONS.DuplicateTimeZone, {
                _providerStatus: ValidationErrors.DUPLICATE_TIME_ZONE_GROUP,
                timeZones: errorThrown.timeZones
            });

            if (errorThrown.exception === EXCEPTIONS.DuplicateEffectiveDatesInUserSchedulesException ||
                errorThrown.exception === EXCEPTIONS.DuplicateEffectiveDatesInUserRatesException) {
                error.handle({
                    _providerStatus: ValidationErrors.DUPLICATED_EFFECTIVE_DATE,
                    ...errorThrown
                })
            }

            if (errorThrown.exception === EXCEPTIONS.AccountDisabledDueToThisProductLicenseException) {
                alert(messageResource.getMessage("user.edit.js.cannot_enable.at_license"));
                error.handle({
                    _providerStatus: ValidationErrors.DISABLED_DUE_TO_LICENSE_TERMS
                });
            }
            if (errorThrown.exception === EXCEPTIONS.AccountDisabledDueToOtherProductLicenseException) {
                alert(messageResource.getMessage("user.edit.js.cannot_enable.ap_license"));
                error.handle({
                    _providerStatus: ValidationErrors.DISABLED_DUE_TO_LICENSE_TERMS
                });
            }

            if (errorThrown.exception === EXCEPTIONS.EditUserConfirmationIsNeededException ||
                errorThrown.exception === EXCEPTIONS.DeleteUserConfirmationIsNeededException) {

                const confirmationMessage = (errorThrown.exception === EXCEPTIONS.EditUserConfirmationIsNeededException) ?
                                            new UserListConfirmation().createEditConfirmationMsg(errorThrown) :
                                            new UserListConfirmation().createDeleteConfirmationMsg(errorThrown)
                if (confirm(confirmationMessage)) {
                    error.handle({
                        _providerStatus: ValidationErrors.ACTION_CONFIRMED,
                    })
                } else {
                    error.handle({
                        _providerStatus: ValidationErrors.ACTION_NOT_CONFIRMED,
                    })
                }
            }

            error.handleOnException(EXCEPTIONS.NoSuchUserGroupException, new NoSuchUserGroupError())
            error.handleOnException(EXCEPTIONS.SelectedUserDeletedException, new SelectedUserDeletedError())
        }

        rpcCall(method, params, _rpcErrorHandler)
            .then((data) => {
                if (_.isUndefined(data.resultCode) || data.resultCode === UserManagementConstants.RESULT_CODE_SUCCESS) {
                    resolve(data)
                }

                if (data.resultCode === UserManagementConstants.ERROR_NO_RIGHTS_TO_MANAGE_ACCOUNT_SETTINGS) {
                    alert(messageResource.getEscapedMessage("userlist.js.error_manage_account_settings_right_revoked"))
                    window.location.reload();
                    return;
                }
                const Code2ErrorMap = {
                    [UserManagementConstants.PASSWORD_RESTRICTIONS_VIOLATED]: ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED,
                    [UserManagementConstants.PASSWORD_COPY_EMPTY]: ValidationErrors.PASSWORD_COPY_EMPTY,
                    [UserManagementConstants.PASSWORD_EMPTY]: ValidationErrors.PASSWORD_EMPTY,
                    [UserManagementConstants.PASSWORD_COPY_MISMATCH]: ValidationErrors.PASSWORDS_DO_NOT_MATCH,
                    [UserManagementConstants.ERROR_NO_SUCH_USER]: ValidationErrors.NO_SUCH_USER,
                    [UserManagementConstants.ERROR_DUPLICATE_USERNAME]: ValidationErrors.DUPLICATE_USERNAME,
                    [UserManagementConstants.ERROR_CANNOT_DISABLE_LAST_USER_MANAGER_IN_OTHER_PRODUCT]: ValidationErrors.LAST_MANAGER_IN_OTHER_PRODUCT,
                }
                let status = Code2ErrorMap[data.resultCode];
                if (status) {
                    reject({...data, _providerStatus: status})
                }
            })
            .catch(reject)
    })
}

const updateStateFromUpdateResult = (result) => (dispatch) => {
    dispatch(setLicenseCounters(result.licenseCounters))
    dispatch(setViewerSettings(result.viewerSettings))
    if (result.userGroups) {
        dispatch(setUserGroupsList(result.userGroups))
    }
    if (result.timeZoneGroups) {
        dispatch(setTimeZoneGroupsList(result.timeZoneGroups))
    }

    dispatch(setEnabledFeatures(result.viewerSettings.enabledFeatures))
    dispatch(addUser(result.userInfo))
}

const updateStateFromEditUserData = (data) => (dispatch) => {
    if (data.userManagementData.allUserGroups) {
        dispatch(setUserGroupsList(data.userManagementData.allUserGroups))
    }
    if (data.userManagementData.allTimeZoneGroups) {
        dispatch(setTimeZoneGroupsList(data.userManagementData.allTimeZoneGroups))
    }
    dispatch(updateStateFromViewerSettings(data.userManagementData.viewerSettings))

    SyncCallbacks.onUpdateUserData(data.userManagementResult)
}

const updateStateOnUserDelete = (id) => dispatch => {
    dispatch(removeUser(id))
}

const updateStateOnUserDeleteSuccess = (id, result) => dispatch => {
    dispatch(setLicenseCounters(result.licenseCounters))
    dispatch(setViewerSettings(result.viewerSettings))
    if (result.userGroups) {
        dispatch(addUserGroups(result.userGroups))
    }
    if (result.timeZoneGroups) {
        dispatch(addTimeZoneGroups(result.timeZoneGroups))
    }
    dispatch(setEnabledFeatures(result.viewerSettings.enabledFeatures))
    dispatch(updateStateOnUserDelete(id))
}

const setUsersAutoApproved = () => (dispatch, getState) => {
    const state = getState()
    const users = Object.values(getUsersList(state)).map(user => ({...user, requiresTTApproval: false}))
    dispatch(addNewUsersToList(users))
    const entitiesUsers = Object.values(getUsers(state)).map(user => ({...user, requiresTTApproval: false}))
    dispatch(addUsers(entitiesUsers))
}




// WEBPACK FOOTER //
// ./web/js/panels/user/editPanel/actions.js